export async function addStateList() {
    const result = await api.get_states()
    const states = result.payload
    let state_list = document.getElementById("state_list")
    let ul = document.createElement("ul")

    for (let i = 0; i < states.length; i++) {
        let a = document.createElement("span")
        a.setAttribute("class", "btn")
        const abbr = states[i].code
        const state = states[i].name
        let li = document.createElement("li")
        li.setAttribute("name", state)
        li.setAttribute("id", abbr)
        a.appendChild(document.createTextNode(states[i].name))
        li.appendChild(a)
        ul.appendChild(li)
    }
    state_list.appendChild(ul)
}

export async function addCountyList(abb, state, addLink = false, options) {
    const response = await api.get_counties_for_state_by_code({code: abb}, options)
    const county_list = document.getElementById("county_list")
    const ul = document.createElement("ul")
    const data = response.payload
    for (let [fips, county] of Object.entries(data)) {
        let name = county.name
        let id = name.replace(/\./g, "").replace(/ /g, "_")
        /**
         * Workaround for St. Louis, Missouri county name duplicate
         *
         * St. Louis city is an independent city meaning, it's at the same governance level as a county
         * St. Louis is also the name of a county in missouri.
         * Certain parts of the code break when counties within a state share a name.
         * This workaround renames St. Louis independent city to St Louis An in the bottom bar.
         * as of 4/4/2024 St Louis the independent city has fips code 29510
         * as of 4/4/2024 St Louis the county has fips code 29189
         * @todo Rework everthing to use FIPS instead of names
         */
        if (fips === "29510") {
            id = "St_Louis_An"
        }

        // Workaround for API stripping fips initial 0
        if (fips.toString().length == 4) {
            fips = "0" + fips
        }

        let a = document.createElement("span")
        a.setAttribute("class", "btn")

        let option = document.createElement("option")
        option.setAttribute("value", name)
        option.appendChild(document.createTextNode(name))

        if (addLink) a.setAttribute("href", "/?fips=" + fips)

        let li = document.createElement("li")
        if (name == county) {
            console.log(name, county)
            ul.setAttribute("class", "selected")
            li.setAttribute("class", "selected")
            option.selected = true
        }
        li.setAttribute("id", id)
        li.setAttribute("fips", fips)

        a.appendChild(document.createTextNode(name.replace(/\./g, "")))
        li.appendChild(a)
        ul.appendChild(li)
    }
    county_list.appendChild(ul)
    return null
}

function emptyCountyList() {
    const list = document.querySelector(".county_list")
    if (list) list.innerText = ""
}

/**
 * Switch the nav list from states to counties, or from one county list to another
 * @param {String} stateAbbr Two-letter abbreviation of the US state containing the county
 * @param {String} countyFips Five-letter FIPS code of the county being switched to
 * @returns {Promise} Promise that switch is complete. true if a new county list was added, false if called on the same county list that is currently loaded.
 */
let countyListAbortController = new AbortController()

export function switchToCountyList(stateAbbr, countyFIPS) {
    let lastState = ""
    // If the state is the same as the last state, bail
    if (
        stateAbbr === lastState &&
        document.querySelector(".county_list").innerText !== ""
    )
        return Promise.resolve(false)

    // Save the previous county list for future deletion
    const oldList = document.querySelector(".county_list ul")

    // Set the last state
    lastState = stateAbbr

    // Add the new county list
    return addCountyList(stateAbbr, undefined, false, {signal: countyListAbortController.signal}).then(() => {
        countyListAbortController.abort()
        countyListAbortController = new AbortController()
        console.log("adding county list")

        // Remove the old list
        oldList?.remove()

        // Hide "United States of America"
        document.querySelector("#USA").classList.add("hidden")

        // Not sure what this does
        document.querySelector(".state_list ul").classList.add("selected")

        // Hide every other state button
        document.querySelectorAll(".state_list ul li").forEach((ele) => {
            if (ele.getAttribute("id") === stateAbbr) {
                ele.classList.add("selected")
                ele.classList.remove("highlighted")
                ele.classList.remove("hidden")
                return
            }

            ele.classList.remove("selected")
            ele.classList.add("hidden")
        })

        return true
    })
}

export function switchToStateList(stateAbbr) {
    document.querySelector("#USA").classList.remove("hidden")
    document.querySelector(".state_list ul")?.classList.remove("selected")
    document.querySelectorAll(".state_list ul li").forEach((ele) => {
        if (ele.getAttribute("id") === stateAbbr) {
            ele.classList.remove("selected")
            ele.classList.add("highlighted")
            ele.classList.remove("hidden")
            return
        }

        ele.classList.remove("selected")
        ele.classList.remove("hidden")
    })
    document.querySelector(".county_list").innerText = ""
}

export function resetList() {
    document.querySelector("#USA").classList.remove("hidden")
    document.querySelector(".state_list ul")?.classList.remove("selected")
    document.querySelectorAll(".state_list ul li").forEach((ele) => {
        ele.classList.add("hidden")
        ele.classList.remove("highlighted")
        ele.classList.remove("selected")
    })
    document.querySelector(".county_list").innerText = ""
}

export function scrollBottomBarToHighlighted(listName) {
    const ul = document.querySelector("." + listName + " ul")
    let li = document.querySelector("." + listName + " ul li.highlighted")
    if (!li) li = document.querySelector("." + listName + " ul li.selected")

    const r1 = ul.getBoundingClientRect()
    const r2 = li.getBoundingClientRect()

    if (!r2.height || !r1.height) {
        return false
    }

    let position =
        r2.x - r1.x + ul.scrollLeft - window.innerWidth / 2 + r2.width / 2
    ul.scrollTo({left: position, behavior: "smooth"})

    return true
}

export function toggleDropdown(button) {
    const list = button.parentElement.querySelector(".drop-list")
    list.classList.toggle("hidden")
    const arrow = button.querySelector(".drop-arrow")
    arrow.classList.toggle("dropped")
}

export function expandDropdown(button) {
    const list = button.parentElement.querySelector(".drop-list")
    list.classList.remove("hidden")
    const arrow = button.querySelector(".drop-arrow")
    arrow.classList.add("dropped")
}

export function collapseDropdown(button) {
    const list = button.parentElement.querySelector(".drop-list")
    list.classList.add("hidden")
    const arrow = button.querySelector(".drop-arrow")
    arrow.classList.remove("dropped")
}
